import React from "react";
import IconEmpowerment from "../../assets/icons/empowerment.svg";
import IconRespect from "../../assets/icons/respect.svg";
import IconSafety from "../../assets/icons/safety_1.svg";

const features = [
  {
    icon: IconEmpowerment,
    title: "Empowerment",
  },
  {
    icon: IconRespect,
    title: "Respect",
  },
  {
    icon: IconSafety,
    title: "Safety",
  },
];

const OurPhilosophy = () => {
  return (
    <section className="py-10 px-10 font-poppins mb-[50px] lg:mb-[100px]">
      <div className="max-w-screen-xl mx-auto text-center">
        <h2 className="text-[var(--primary-orange-color)] text-[24px] lg:text-[32px] xl:text-[36px] font-semibold mb-2 uppercase">
          OUR PHILOSOPHY OF CARE
        </h2>
        <p className="text-[12px] lg:text-[18px] xl:text-[20px] text-[var(--light-gray-color)] leading-relaxed mb-8 sm:mb-[100px]">
          At Roselea Care Homes, life is about more than just care it’s about
          community, growth, and meaningful experiences. We provide a supportive
          and structured environment where individuals with learning
          disabilities (LD), autism spectrum disorder (ASD), and mental health
          (MH) needs can feel safe, respected, and empowered.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center px-2">
              <div className="bg-green hover:bg-[var(--primary-orange-color)] w-14 h-14 sm:w-[107px] sm:h-[107px] rounded-full flex items-center justify-center ">
                <img src={feature.icon} alt={feature.title} />
              </div>
              <h3 className="lg:text-[24px] xl:text-[32px] font-semibold text-green mt-6 sm:mt-[44px] mb-4 sm:mb-[29px]">
                {feature.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPhilosophy;
